"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const react_dom_1 = __importDefault(require("react-dom"));
require("@fontsource/roboto/300.css");
require("@fontsource/roboto/400.css");
require("@fontsource/roboto/500.css");
require("@fontsource/roboto/700.css");
const HistMapApplication_1 = __importDefault(require("./components/HistMapApplication"));
const model_1 = require("./model");
const data_1 = __importDefault(require("./data"));
const geojsons = (0, model_1.getGeoJSONs)(require.context("../frontlines", false, /.geojson$/));
react_dom_1.default.render(react_1.default.createElement(HistMapApplication_1.default, { hits: data_1.default, geojsons: geojsons }), document.querySelector("#root"));
